export default "__VITE_ASSET__DN3V5tD7__"